<template>
    <v-card :color="color" dark @click="clickCard()">
        <v-list-item>
            <v-icon class="display-2">{{ icon }}</v-icon>
            <v-list-item-content class="text-right">
                <span class="display-2 font-weight-light">{{ num_data }}</span>
                <br />
                <span class="subtitle-1 font-weight-medium text-uppercase">{{
                    title
                }}</span>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
export default {
    props: ["color", "icon", "num_data", "title"],
    methods: {
        clickCard() {
            this.$emit("onClick")
        },
    },
}
</script>
